var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Manufacturer-info"},[_c('div',{staticClass:"manufacturer-img"},[_c('img',{attrs:{"src":_vm.manufacturer.img,"alt":"厂家信息"}})]),_c('div',{staticClass:"manufacturer-name"},[_vm._v(_vm._s(_vm.manufacturer.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }